import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import { ImageComponent, UserInfoComponent, UserTypeComponent } from '../../components';
import '../../common/theme/UserFlowPage.scss';
import logo from './../../common/assets/img/agent-account-create-image.png';

const UserFlowPage = () => {
  const history = useHistory();
  const [selectedUserType, setSelectedUserType] = useState(undefined);
  const [typeWasSelected, setTypeWasSelected] = useState(false);
  const [userData, setUserData] = useState(undefined);

  const sendEncryptedUserData = (encryptData) => {
    history.push('/signup?userdata=' + encryptData);
  }

  const handlePrevStep = (prevStep) => {
    switch (prevStep) {
      case 'welcome': 
        history.goBack();
        break;
      case 'userType':
        setTypeWasSelected(false);
        break;
      case 'userInfo':
        setUserData(undefined);
        break;
      case 'userEmail':
        setUserData((prevUserData) => {
          const updatedUserData = { ...prevUserData };
          delete updatedUserData['useremail'];
          return updatedUserData;
        });
        break;
      default:
        break;
    }
    window.scroll(0, 0);
  };

  const handleSelectUserType = (accountType) => {
    setSelectedUserType(accountType);
    setTypeWasSelected(true);
  };

  return (
    <div className='userFlow agent-ciam-container'>
      <div className='userFlow-container'>
        <Grid container justify='space-between' className='container-styling'>
          <Grid item sm={12} md={12} lg={5}>
            <ImageComponent src={logo} />
          </Grid>
          <Grid item sm={12} md={12} lg={7}>
            <Box>
              { (!!typeWasSelected && !userData) && ( 
                <UserInfoComponent selectedUserType={selectedUserType} sendEncryptedUserData={sendEncryptedUserData} handlePrevStep={handlePrevStep} />
              )}
              { (!typeWasSelected) && ( 
                <UserTypeComponent handleSelectUserType={handleSelectUserType} handlePrevStep={handlePrevStep} selectedUserType={selectedUserType} />
              )}
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default UserFlowPage;
